<script lang="ts">
    import BarLoader from "svelte-loading-spinners/BarLoader.svelte"
    import { getCachedEntries } from "../../../../api"
    import { spaNavigate } from "../../../../functionTools/navigation"
    import { langField } from "../../../../i18n"
    import { location } from "../../../../i18n"

    import { _ } from "svelte-i18n"
    import Icon from "../../../widgets/Icon.svelte"
    import { mdiTagEditOutline } from "@mdi/js"
    import { overlay } from "../../../../store"
    import ColorVariantSelector from "./ColorVariantSelector.svelte"

    let {
        product,
        setActiveImage,
    }: {
        product: Product
        setActiveImage: (idx: number) => void
    } = $props()

    let other_variants: Product[] = $state([])
    let loading = $state(true)

    async function loadVariants() {
        if (product.variant_codes?.length) {
            other_variants = await getCachedEntries(
                "product",
                { code: { $in: product.variant_codes } },
                null,
                null,
                null,
                "variant"
            )
            if (other_variants) {
                other_variants = other_variants.sort(
                    (a, b) => product.variant_codes.indexOf(a.code) - product.variant_codes.indexOf(b.code)
                )
            }
        } else {
            other_variants = []
        }

        loading = false
    }
    loadVariants()
</script>

{#if product.variant_codes?.length}
    {#if loading}
        <BarLoader />
    {:else if other_variants?.length}
        <br />
        <label for="variant-select" style="font-size: 0.7em; font-weight: bold;">
            {$_("product.variant")}
        </label>
        <select
            id="variant-select"
            onchange={(e) => {
                const v: string = (e.target as HTMLSelectElement).value
                const product = other_variants.find((variant) => variant.code == v)
                const detailsHref = `${$location.path && $location.path != "/" ? $location.path + "/" : ""}../${product.code}_${langField(product.slug, "")}`
                spaNavigate(detailsHref, { replace: true })
            }}
        >
            {#each other_variants as variant}
                <option value={variant.code} selected={product.code == variant.code}>
                    {langField(variant?.variant_name, $_("product.1-piece"))}
                </option>
            {/each}
        </select>
    {/if}
{/if}
<div class="product-config-wrapper">
    <ColorVariantSelector {product} colorVariants={product._color_variants || []} replaceHistory={true} />
    {#if product.lasersheet_configurator?.length}
        <button
            class="button primary lasersheet-activation-button"
            onclick={() => {
                $overlay = {
                    show: true,
                    type: "lasersheet",
                    properties: {
                        product,
                        setActiveImage,
                    },
                }
            }}
        >
            <Icon path={mdiTagEditOutline} size="24px" />
            <span>{$_("product.configure-lasersheet")}</span>
        </button>
    {/if}
</div>

<style lang="less">
    @import "../../../../css/variables.less";

    .product-config-wrapper {
        display: flex;
        gap: 1.2rem;
        justify-content: space-between;
        align-items: center;

        .lasersheet-activation-button {
            display: none;
        }
        @media @max-mobile-product {
            .lasersheet-activation-button {
                width: fit-content;
                display: flex;
                justify-content: center;
                align-items: center;
                gap: 0.6rem;
            }
        }
        @media (max-width: 500px) {
            flex-direction: column;
            align-items: flex-start;
            .lasersheet-activation-button {
                width: 100%;
            }
        }
    }
</style>
